import { keyframes } from './'

const fade = (fadeIn, fadeUp) =>
  keyframes({
    '0%': {
      opacity: fadeIn ? 0 : 1,
      transform: `translate3d(0, ${fadeUp ? '1%' : '-1%'}, 0)`
    },
    '100%': {
      opacity: fadeIn ? 1 : 0,
      transform: 'translate3d(0, 0, 0)'
    }
  })

export const styles = {
  fonts: {
    headline: "'Brandon', sans-serif",
    body: "'Inter', sans-serif",
    data: "'Inter', sans-serif"
  },
  colors: {
    backgroundGrey: '#e9ecf0',
    primary: 'rgb(21,40,75)',
    secondary: 'rgb(255,80,0)',
    paleGreen: '#6aaf6a',
    paleOrange: '#ffae19',
    paleRed: '#ff6666',
    palePurple: 'rgb(162,138,210)',
    paleBlue: 'rgb(120,140,200)',
    paleYellow: 'rgb(241, 225, 91)',
    chart: [
      'rgb(255,80,0)',
      'rgb(21,40,75)',
      'rgb(50,93,121)',
      'rgb(249,162,108)',
      'rgb(36,67,98)',
      'rgb(252,121,54)'
    ]
  },
  mediaQueries: {
    phone: '@media only screen and (min-width: 0px) and (max-width: 768px)',
    tablet: '@media only screen and (min-width: 769px) and (max-width: 1350px)',
    phoneAndTablet:
      '@media only screen and (min-width: 0px) and (max-width: 1350px)',
    tabletAndDesktop: '@media only screen and (min-width: 769px)',
    desktop: '@media only screen and (min-width: 1350px)'
  },
  animations: {
    fadeInDown: { animation: `${fade(true, false)} 400ms ease` },
    fadeInUp: { animation: `${fade(true, true)} 400ms ease` },
    fadeOutDown: { animation: `${fade(false, false)} 400ms ease` },
    fadeOutUp: { animation: `${fade(false, true)} 400ms ease` }
  },
  boxShadow: '0 5px 15px rgba(50,50,93,0.05), 0 3px 5px rgba(0,0,0,0.03)',
  border: '1px solid #e9ecf0',
  borderRadius: 0
}
